module.exports = __webpack_public_path__ + "static/media/signup.ac979b12.jpg";